export default __webpack_public_path__ + "assets/48f518.jpg";